import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterMenu'
})
export class FilterMenuPipe implements PipeTransform {

   leftMenuDetails = [
    {
      title: "LOGIN",
      normalimg: "assets/login_normal.png",
      selectimg: "assets/login_sel.png",
      icon: "fas fa-lock",
      disabled: true,
    },
    {
      title: "FRIENDS",
      normalimg: "assets/friends_nor.png",
      selectimg: "assets/friends_sel.png",
      icon: "fas fa-users",
      disabled: true,
    },
    {
      title: "MINGLE",
      normalimg: "assets/mingle_white.png",
      selectimg: "assets/mingle_blue.png",
      isPng: true,
      disabled: true,
    },
    {
      title: "BUSINESS",
      normalimg: "assets/network_white.png",
      selectimg: "assets/network_blue.png",
      isPng: true,
      disabled: true,
    },
    {
      title: "FOLLOW",
      normalimg: "assets/follow_white.png",
      selectimg: "assets/follow_blue.png",
      isPng: true,
      disabled: true,
    },
    {
      title: "FAVORITES",
      normalimg: "assets/fav_nor.png",
      selectimg: "assets/fav_sel.png",
      icon: "fas fa-heart",
      isPng: true,
      disabled: true,
    }
  ];

  transform(menus: any[], type: string): any[] {
    if(type == 'h') {
      this.leftMenuDetails = [   
        {
        title: "LOGIN",
        normalimg: "assets/login_normal.png",
        selectimg: "assets/login_sel.png",
        icon: "fas fa-lock",
        disabled: true,
      }]
    }
    let titlesToFilter: string[];

    switch (type) {
      case 'm':
        titlesToFilter = ['login','home', 'videos', 'photos', 
          'concerts & shows', 'parties & events', 'music', 'nightclubs', 'bars', 'news'];
        break;
      case 'n':
        titlesToFilter = ['login','videos', 'photos', 'nightclubs', 'bars', 'restaurants','concerts & shows',
          'parties & events','hotels & resorts','transportation', 'music','movies','fashion news','news'];
        break;
      case 'd':
        titlesToFilter = ['login','videos', 'photos', 'nightclubs', 'bars', 'restaurants','concerts & shows',
            'parties & events','hotels & resorts','transportation', 'music','movies','fashion news','news'];
          break;
      case 'h':
           titlesToFilter = ['login','videos', 'photos'];
            break;
      default:
        titlesToFilter = [ ];
    }

    // Filter menus based on titlesToFilter
    let filteredMenus = menus.filter(menu => 
      titlesToFilter.includes(menu.title.toLowerCase())
    );

    // Find missing titles
    const missingTitles = titlesToFilter.filter(title => 
      !menus.some(menu => menu.title.toLowerCase() === title)
    );

    // Add default items from leftMenuDetails for missing titles
    missingTitles.forEach(title => {
      const defaultMenu = this.leftMenuDetails.find(menu => 
        menu.title.toLowerCase() === title
      );
      if (defaultMenu) {
        filteredMenus.push(defaultMenu);
      }
    });

    // Sort filteredMenus to match the order of titlesToFilter
    const sortedMenus = titlesToFilter.map(title => 
      filteredMenus.find(menu => menu.title.toLowerCase() === title)
    ).filter(menu => menu !== undefined);

    return sortedMenus;
  }
}
